/** @file Setup transform and length of a socket bone from its grip axis (origin a, X axis toward b). */
import { angle } from '@pose2d/math/angle';
import { trig } from '@pose2d/math/trig';
import { throwError } from '@pose2d/format/throwError';
import type { LocalTransform } from '@pose2d/format/types';

/** a → x, y; direction a→b → rotation (deg); |b − a| → length; unit scale, no shear. VALIDATION at `b` when a = b. */
export function gripSetup(a: readonly [number, number], b: readonly [number, number]): { setup: LocalTransform; length: number } {
  const dx = b[0] - a[0];
  const dy = b[1] - a[1];
  const length = trig.hypot(dx, dy);
  if (length === 0) throwError('VALIDATION', undefined, { path: 'b', hint: 'a and b must differ: the grip axis needs a direction' });
  return { setup: { x: a[0], y: a[1], rotation: angle.radToDeg(trig.atan2(dy, dx)), scaleX: 1, scaleY: 1, shearX: 0, shearY: 0 }, length };
}
